import jsPDF from "jspdf";
import html2canvas from "html2canvas";

const handleDownloadReport = async () => {
  const pdf = new jsPDF("l", "mm", "a4");
  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();

  const chartContainers = document.querySelectorAll(".chart-container");
  if (chartContainers.length === 0) {
    alert("No graphs found!");
    return;
  }

  const staticTitles = [
    "Top 5 Capabilities - User Activity",
    "User Activity - Daily Usage",
    "Top 10 Services - Platform Usage",
    "Top 3 Projects - User Activity",
  ];

  const chartWidth = pageWidth / 2 - 20; // Two per row
  const chartHeight = pageHeight / 2 - 20; // Two per column

  for (let i = 0; i < chartContainers.length; i++) {
    const chart = chartContainers[i];
    const canvas = await html2canvas(chart, { scale: 3 });
    const imgData = canvas.toDataURL("image/png");

    // Maintain aspect ratio within bounds
    let imgWidth = chartWidth;
    let imgHeight = (canvas.height * imgWidth) / canvas.width;
    if (imgHeight > chartHeight - 10) {
      imgWidth = (canvas.width * (chartHeight - 10)) / canvas.height;
      imgHeight = chartHeight - 10;
    }

    const col = i % 2;
    const row = Math.floor(i / 2) % 2;
    const pageIndex = Math.floor(i / 4);

    if (i > 0 && i % 4 === 0) {
      pdf.addPage();
    }

    const xOffset = 10 + col * (pageWidth / 2);
    const yOffset = 20 + row * (pageHeight / 2);

    // Add title
    pdf.setFontSize(11);
    pdf.text(staticTitles[i] || `Chart ${i + 1}`, xOffset, yOffset - 5);

    // Add image
    pdf.addImage(imgData, "PNG", xOffset, yOffset, imgWidth, imgHeight);
  }

  pdf.save("Dashboard report.pdf");
};

export default handleDownloadReport;
